import { Role } from './role';

export interface AdminPrivileges {
  userCountries: string[];   // e.g. ['MY', 'SG'] — empty = unrestricted
  contentAccess: boolean;
  paymentCountries: string[]; // empty = unrestricted
}

export class User {
  id: number;
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  avatar: string;
  role: Role;
  token?: string;
  privileges?: AdminPrivileges;
}
